export const STATUS_MAP = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  complete: 'Complete',
  requires_attention: 'Required Attention',
  not_required: 'Not Required',
};

export default STATUS_MAP;
